<template>
  <div class="fff-modal tips-modal">
    <div
      class="overlay"
      @click="hide"
    />
    <div class="box">
      <div
        class="close-modal"
        @click="hide"
      >
        &times;
      </div>
      <h4 class="text-center">
        Tip of the Day
      </h4>
      <div class="tips-slider">
        <div
          v-show="tips.length > 1"
          class="arrow left"
          @click="prev()"
        >
          <i class="fas fa-chevron-left" />
        </div>
        <div class="items">
          <div
            v-for="(tip, index) in tips"
            v-show="current_index == index"
            class="item"
          >
            "{{ tip.message }}"
          </div>
        </div>
        <div
          v-show="tips.length > 1"
          class="arrow right"
          @click="next()"
        >
          <i class="fas fa-chevron-right" />
        </div>
      </div>
      <div class="buttons">
        <div class="button-container">
          <a
            class="button"
            @click.prevent="hide"
          >Got it!</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['tips'],
  data () {
    return {
      current_index: 0,
    }
  },
  methods: {
    show() {
      this.$emit('show-modal');
    },
    hide() {
      this.$emit('hide-modal');
    },
    prev() {
      this.current_index = this.current_index - 1;
      if (this.current_index < 0) {
        this.current_index = this.tips.length - 1;
      }
    },
    next() {
      this.current_index = this.current_index + 1;
      if (this.current_index + 1 > this.tips.length) {
        this.current_index = 0;
      }
    },
  },
}
</script>

<style lang="scss" scoped>

</style>